import get from 'lodash/get';
import * as actions from './constants';
import { responseToMessage } from '../../views/message';
import * as chatActions from '../../../modules/chat/app/ChatApp/actions';
import * as chatAppSelectors from '../../../modules/chat/app/ChatApp/selectors';
import * as chatSoundActions from '../../../modules/chat/app/ChatAppSound/actions';

export const onSocketTypeUnknown = (event, message) => {
  return { type: actions.SOCKET_TYPE_UNKNOWN, message, event };
};

export const handleClippedMessage = message => {
  const messageId = get(message, 'id');

  return (dispatch, getState) => {
    const sessionId = chatAppSelectors.getActiveSessionId(getState());
    dispatch(chatActions.handleFetchChatMessageById({ messageId, sessionId }));
  };
};

export const handleSocketTypeMessage = socketMessage => dispatch => {
  const isClipped = get(socketMessage, 'data.clipped');
  const cleanMessage = responseToMessage(socketMessage);

  if (isClipped) {
    dispatch(handleClippedMessage(cleanMessage));
  } else {
    dispatch(chatActions.onMessageReceived(cleanMessage));
  }

  if (get(cleanMessage, 'sentBy.id') !== '__team') {
    dispatch(chatActions.handleChatFetchUserId(cleanMessage.sentBy.id));
  }

  dispatch(chatSoundActions.chatSoundPlay());
  return dispatch(chatActions.handleUpdateActiveSessionSeen());
};

export const onSocketMessage = (eventName, socketMessage) => {
  const MESSAGE_TYPE_ROOM_MESSAGE = 'kustomer.app.chat.message.send';
  return (dispatch, getState) => {
    switch (eventName) {
      case MESSAGE_TYPE_ROOM_MESSAGE: {
        const message = responseToMessage(socketMessage);
        const sessionEntities = chatAppSelectors.getSessionEntities(getState());
        const sessionId = get(message, 'sessionId');
        const sessionExists = sessionEntities.get(sessionId);

        if (!sessionExists) {
          dispatch(chatActions.handleInitCustomerData({ withoutCache: true }));
        }

        return dispatch(handleSocketTypeMessage(socketMessage));
      }
      default: {
        return dispatch(onSocketTypeUnknown(eventName, socketMessage));
      }
    }
  };
};
